import { render, staticRenderFns } from "./PTopNotice.vue?vue&type=template&id=62a55eb7&"
import script from "./PTopNotice.vue?vue&type=script&lang=js&"
export * from "./PTopNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports